import { StatusLabel } from 'components/common-form/sidePanel/status/initialized/StatusLabel';
import { FC } from 'react';

export const SuccessStatus: FC<{}> = () => (
  <StatusLabel labelKey="tradeAllocation.sidePanel.status.success" color="info" />
);

SuccessStatus.displayName = 'SuccessStatus';
